import { useSelector } from "react-redux";
import UniqueDefinitionsTable from "./UniqueDefinitionsTable";
import { useEffect } from "react";
import { UniqueDefinitionsEndpointLogic } from "../../../../logic/DataCollection/Unifier/UniqueDefinitionsEndpointLogic";
import { setLoading } from "../../../../features/uniqueDefSlice";
import { selectUserToken } from "../../../../features/userSlice";
import SimpleBackdrop from "../../../BackDrop/BackDrop";
import { useDispatch } from "react-redux";

const tableHeadings = {
  id: "Definition ID",
  affiliate_system_interface: "Interface Name",
  destination_table_name: "Destination Table",
};

const UniqueDefinitions = () => {
  const loading = useSelector((state: any) => state.uniqueDefinition.loading);
  const { uniqueDefinitionDataAll } = useSelector(
    (state: any) => state.uniqueDefinition,
  );
  const dispatch = useDispatch();
  const oauthTokenHeader: any = useSelector(selectUserToken);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(setLoading(true));
      try {
        await UniqueDefinitionsEndpointLogic.getAllUnifierUniqueDefinitions(
          oauthTokenHeader,
        );
      } catch (e: any) {
        console.error("Error fetching data:", e);
      } finally {
        dispatch(setLoading(false));
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <UniqueDefinitionsTable
            tableHeadings={tableHeadings}
            rows={uniqueDefinitionDataAll}
          />
        </>
      )}
    </>
  );
};

export default UniqueDefinitions;
